<template>
	<div class="reservation-secret">
		<div class="page-container">
			<PageTitle ch="操偶師職人實境體驗" en="Guided Tour"></PageTitle>
			<BannerSplit2ReservationSecter></BannerSplit2ReservationSecter>
			<div class="center">
				<img class="apply" src="/static/assets/exp/img_deco.png" alt="">
			</div>
		</div>
	</div>
</template>


<script>
import PageTitle from '@/components/page_title'
import BannerSplit2ReservationSecter from '@/components/banner/banner_split2_reservation_secret'

export default {

  metaInfo: {
    title: '利澤國際偶戲藝術村'
  },
  name: 'reservation_secret',
  data() {
    return {
    }
  },
  components: {
    PageTitle,
    BannerSplit2ReservationSecter
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  @import '../../stylesheet/base.sass'
  @import '../../stylesheet/layout.sass'

  .reservation-secret
    iframe
      +size(100%, 1000px)
    .center
      +flexLayout('center', 'row')
      width: 100%
      margin: 200px 0
      .apply
        width: 100%
        max-width: 1000px



</style>



// WEBPACK FOOTER //
// src/pages/reservation/reservation_secret.vue